import { LocaleMessages } from 'vue-i18n'

const docPtBrLocaleMessages: LocaleMessages = {
  dfeXml: {
    title: 'DF-e XML',
    pluralTitle: 'DF-e XMLs',
    field: {
      tipo: 'Tipo',
      operacao: 'Operação',
      dataHora: 'Data e hora',
      timeZoneOffset: 'Fuso horário',
      serie: 'Série',
      numero: 'Número',
      chave: 'Chave',
      valor: 'Valor',
      inscricaoEmitente: 'Emitente',
      inscricaoDestinatario: 'Destinatário',
      inscricaoTransportador: 'Transportador',
      tamanho: 'Tamanho',
      checksum: 'Checksum',
      inscricao: 'Inscrição',
      periodo: 'Período',
      pluralTipo: 'Tipos',
      pluralOperacao: 'Operações'
    },
    alert: {
      download: 'Informe uma inscrição e um período para baixar todos os XMLs de uma só vez.'
    },
    value: {
      tipo: {
        NFE: 'NF-e',
        NFE_CANCELADO: 'NF-e (Cancelado)',
        NFE_DENEGADO: 'NF-e (Denegado)',
        CTE: 'CT-e',
        CTE_CANCELADO: 'CT-e (Cancelado)',
        CTE_DENEGADO: 'CT-e (Denegado)',
        CTEOS: 'CT-e OS',
        CTEOS_CANCELADO: 'CT-e OS (Cancelado)',
        CTEOS_DENEGADO: 'CT-e OS (Denegado)',
        NFSE: 'NFS-e',
        NFSE_CANCELADO: 'NFS-e (Cancelado)',
        NFCE: 'NFC-e',
        NFCE_CANCELADO: 'NFC-e (Cancelado)',
        NFCE_DENEGADO: 'NFC-e (Denegado)',
        SAT: 'SAT',
        SAT_CANCELADO: 'SAT (Cancelado)'
      },
      operacao: {
        ENTRADA: 'Entrada',
        SAIDA: 'Saída'
      }
    }
  },
  dfeXmlUserContext: {
    title: 'DF-e XML do Usuário',
    pluralTitle: 'DF-e XMLs do Usuário'
  }
}

export default docPtBrLocaleMessages